import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { TaxhubService } from '../../api/taxhub.service';
import {
    ObservationFeature,
    Taxon,
    TaxonomyListItem,
} from '../../programs/observations/observation.model';
import { ObservationsService } from '../../programs/observations/observations.service';
import { MainConfig } from '../../../conf/main.config';

@Component({
    selector: 'app-species',
    templateUrl: './species.component.html',
    styleUrls: ['./species.component.css'],
})
export class SpeciesComponent implements OnInit {
    MainConfig = MainConfig;
    specie_id: any;
    taxon: Taxon;
    listItem: TaxonomyListItem;
    observations: ObservationFeature[] = [];
    currentLanguage = 'pt-BR';
    loading = true;
    error = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public taxhub: TaxhubService,
        private http: HttpClient,
        private observationsService: ObservationsService
    ) {
        this.currentLanguage =
            localStorage.getItem('language') === 'fr' ? 'fr' : 'pt-BR';
        this.route.params.subscribe((params) => {
            this.specie_id = params['id'];
        });
    }

    ngOnInit(): void {
        this.taxhub.getTaxon(this.specie_id).subscribe(
            (taxon) => {
                this.taxon = taxon;
                this.loading = false;
                this.error = false;
            },
            () => {
                this.loading = false;
                this.error = true;
            }
        );

        this.http
            .get<TaxonomyListItem[]>(
                MainConfig.API_ENDPOINT + '/taxonomy/lists/101/species',
                { params: { limit: '300' } }
            )
            .subscribe(
                (items) => {
                    this.listItem = (items || []).find(
                        (item) =>
                            item.taxref &&
                            Number(item.taxref.cd_nom) === Number(this.specie_id)
                    );
                },
                () => (this.listItem = null)
            );

        this.observationsService.getRecentObservations(500).subscribe(
            (result) => {
                this.observations = (result.features || []).filter(
                    (feature) =>
                        Number(feature.properties.cd_nom) ===
                        Number(this.specie_id)
                );
            },
            () => (this.observations = [])
        );
    }

    t(portuguese: string, french: string): string {
        return this.currentLanguage === 'fr' ? french : portuguese;
    }

    get heroPhoto(): string {
        if (
            this.listItem &&
            this.listItem.medias &&
            this.listItem.medias.length
        ) {
            return (
                MainConfig.API_ENDPOINT +
                '/tmedias/thumbnail/' +
                this.listItem.medias[0].id_media +
                '?h=900'
            );
        }

        return null;
    }

    get recentSpeciesObservations(): ObservationFeature[] {
        return this.observations.slice(0, 3);
    }

    get iucnStatus(): string {
        return this.getAttribute(2);
    }

    get mmaStatus(): string {
        return this.getAttribute(3);
    }

    get citesStatus(): string {
        return this.getAttribute(4);
    }

    get states(): string {
        return this.getAttribute(5);
    }

    get biomes(): string {
        return this.getAttribute(6);
    }

    get endemic(): string {
        return this.getAttribute(7);
    }

    get sourceVersion(): string {
        return this.getAttribute(1);
    }

    openObservation(observation: ObservationFeature): void {
        if (!observation || !observation.properties) {
            return;
        }

        this.router.navigate([
            '/programs',
            observation.properties.id_program || 1,
            'observations',
            observation.properties.id_observation,
        ]);
    }

    goBackToCatalog(): void {
        this.router.navigate(['/species']);
    }

    getObservationPhoto(observation: ObservationFeature): string {
        if (!observation || !observation.properties) {
            return null;
        }

        if (
            observation.properties.photos &&
            observation.properties.photos.length
        ) {
            return (
                MainConfig.API_ENDPOINT +
                observation.properties.photos[0].url
            );
        }

        if (
            observation.properties.medias &&
            observation.properties.medias.length
        ) {
            return (
                MainConfig.API_ENDPOINT +
                '/tmedias/thumbnail/' +
                observation.properties.medias[0].id_media +
                '?h=500'
            );
        }

        return null;
    }

    getLocation(observation: ObservationFeature): string {
        const value =
            observation && observation.properties
                ? observation.properties.municipality
                : null;

        if (!value || value === 'None' || value === 'None (None)') {
            return this.t('Local não informado', 'Lieu non renseigné');
        }

        return value;
    }

    private getAttribute(id: number): string {
        if (!this.listItem || !this.listItem.attributs) {
            return null;
        }

        const attribute = this.listItem.attributs.find(
            (item) => item.id_attribut === id
        );

        return attribute ? attribute.valeur_attribut : null;
    }
}
